<script setup lang="ts">
import SuccessItem from '@/components/Success/SuccessItem.vue';
import { computed } from 'vue';
import store from '@/store';

const storeSuccess = computed(() => store.getters.storeSuccess);
</script>

<template>
  <div class="mx-3 alert-success">
    <success-item v-for="(item, i) in storeSuccess" :item="item" :index="i" :key="i" />
  </div>
</template>
